import { render, staticRenderFns } from "./StrategyProduction.vue?vue&type=template&id=170cdf4c"
import script from "./StrategyProduction.vue?vue&type=script&lang=js"
export * from "./StrategyProduction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports